import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { closeAllFolderModal } from '../../../actions/folders';
import DisplayFolder from './DisplayFolder';

const FindFolders = React.memo(
  ({
    handleCheckTemplate,
    isLoad,
    errMess,
    selectedTemplateId,
    folders,
    isLoadFolder,
    searchFieldWidth,
    tabSelected,
  }) => {
    if (isLoadFolder) {
      return <Spinner />;
    }
    return (
      <React.Fragment>
        {folders.map((folder) => (
          <DisplayFolder
            key={folder.folder_id}
            handleCheckTemplate={handleCheckTemplate}
            isLoad={isLoad}
            errMess={errMess}
            selectedTemplateId={selectedTemplateId}
            folder={folder}
            searchFieldWidth={searchFieldWidth}
            tabSelected={tabSelected}
          />
        ))}
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const { onAllFolderModal, folders, isLoadFolder } = state.folders;
  return {
    onAllFolderModal,
    folders,
    isLoadFolder,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeAllFolderModal: () => dispatch(closeAllFolderModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FindFolders);

export const Spinner = styled.div`
  display: inline-block;
  margin: 20px;
  width: 50px;
  height: 50px;
  border: 5px solid rgb(3, 3, 3);
  border-radius: 50%;
  border-top-color: rgba(0, 0, 0, 0);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/FindTemplateContainer/FindFolders.jsx